import { Instance, flow, getEnv, types } from "mobx-state-tree";
import { SewerObjectParentEntityFromPath } from "../sewer-object/SewerObjectParentEntityFromPath";
import { EntityTypeFromPath } from "../breadcrumbs/EntityTypeFromPathModel";
import { endpoints } from "../api/ApiEndpoints";

export const CurrentSewerObjectStorageModel = types
  .model("CurrentSewerObjectStorageModel", {
    parentEntityFromPath: types.frozen<SewerObjectParentEntityFromPath>(),
  })
  .actions((self) => {
    return {
      getParentEntityName: flow(function* getParentEntityName(parentProjectName: string) {
        if (self.parentEntityFromPath.type === EntityTypeFromPath.Project) {
          return parentProjectName;
        } else {
          const endpoint = endpoints.get("job");
          endpoint.routeParams = [self.parentEntityFromPath.id];
          const job = yield getEnv(self).api.get(endpoint);
          return job.name;
        }
      }),
    };
  })

export type CurrentSewerObjectStorage = Instance<typeof CurrentSewerObjectStorageModel>;
